"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicParamsService = void 0;
var PublicParamsService = /** @class */ (function () {
    function PublicParamsService() {
        // 是否处于微前端框架中
        this.IN_MICRO_FRONTENDS = !!window['__POWERED_BY_QIANKUN__'];
    }
    return PublicParamsService;
}());
exports.PublicParamsService = PublicParamsService;
